
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { subdomainAuthStorage } from '@/lib/subdomain-auth-storage';

const SUPABASE_URL = "https://byahcnpzuucjjogjqyoi.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJ5YWhjbnB6dXVjampvZ2pxeW9pIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzY0OTU2OTMsImV4cCI6MjA1MjA3MTY5M30.GsyJkHuvJkm4Qm9lghut9-LJEUkJrUOYmTfMhp9jCOs";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

console.log('[SUPABASE] Initializing Supabase client with subdomain-isolated auth storage');

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: subdomainAuthStorage,
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'implicit'
  },
  db: {
    schema: 'public',
  },
  global: {
    fetch: (url: RequestInfo | URL, options?: RequestInit) => {
      // Log all database operations for debugging
      if (options?.method === 'DELETE') {
        console.log('[SUPABASE-CLIENT] DELETE request:', { url, options });
      }
      return fetch(url, options).then(response => {
        if (options?.method === 'DELETE') {
          console.log('[SUPABASE-CLIENT] DELETE response:', { 
            status: response.status, 
            statusText: response.statusText,
            ok: response.ok,
            url: response.url
          });
        }
        return response;
      });
    }
  }
});

// Log current session on client init for debugging
supabase.auth.getSession().then(({ data: { session } }) => {
  console.log('[SUPABASE] Initial session check on client init:', 
    session ? `Session found for user ${session.user.id}` : 'No session found');
});

// Subscribe to auth changes for debugging
const { data } = supabase.auth.onAuthStateChange((event, session) => {
  console.log('[SUPABASE-CLIENT] Auth state change:', event, 
    session ? `User: ${session.user.id}` : 'No session');
});
